import { BadImplementationException, exists } from '@nu-art/ts-common';
const calculate_ExpressionValueTree_Unary = (description, calculationResults) => {
    const inner = calculate_ExpressionValueTree(description.operand, calculationResults);
    let value;
    if (exists(inner?.value))
        switch (description.operator) {
            case 'negative':
                if (typeof inner.value === 'number')
                    value = -inner.value;
                break;
            case 'positive':
                if (typeof inner.value === 'number')
                    value = +inner.value;
                break;
            case 'not':
                if (typeof inner.value === 'boolean')
                    value = !inner.value;
        }
    return { type: 'unary', value, inner };
};
const calculate_ExpressionValueTree_Binary = (description, calculationResults) => {
    const left = calculate_ExpressionValueTree(description.leftHand, calculationResults);
    const right = calculate_ExpressionValueTree(description.rightHand, calculationResults);
    let value;
    switch (description.operator) {
        case 'addition':
        case 'positive':
            if (typeof left?.value === 'number' && typeof right?.value === 'number')
                value = left.value + right.value;
            break;
        case 'subtraction':
        case 'negative':
            if (typeof left?.value === 'number' && typeof right?.value === 'number')
                value = left.value - right.value;
            break;
        case 'multiplication':
            if (typeof left?.value === 'number' && typeof right?.value === 'number')
                value = left.value * right.value;
            break;
        case 'division':
            if (typeof left?.value === 'number' && typeof right?.value === 'number')
                value = left.value / right.value;
            break;
        case 'or':
            if (exists(left) && exists(right))
                value = Boolean(left.value) || Boolean(right.value);
            break;
        case 'and':
            if (exists(left) && exists(right))
                value = Boolean(left.value) && Boolean(right.value);
    }
    return { type: 'binary', left, right, value };
};
const calculate_ExpressionValueTree_Variadic = (description, calculationResults) => {
    const operands = description.operands.map(op => calculate_ExpressionValueTree(op, calculationResults));
    let value;
    switch (description.operator) {
        case 'and':
            value = operands.every(op => Boolean(op?.value));
            break;
        case 'or':
            value = operands.some(op => Boolean(op?.value));
            break;
        case 'addition':
            value = operands.reduce((sum, op) => {
                if (typeof op?.value === 'number')
                    return sum + op.value;
                return sum;
            }, 0);
            break;
        case 'multiplication':
            value = operands.reduce((product, op) => {
                if (typeof op?.value === 'number')
                    return product * op.value;
                return product;
            }, 1);
            if (value === 1) //No op returned a value to multiply...
                value = undefined;
    }
    return { type: 'variadic', operands, value };
};
const calculate_ExpressionValueTree_Range = (description, calculationResults) => {
    const min = calculate_ExpressionValueTree(description.min, calculationResults);
    const max = calculate_ExpressionValueTree(description.max, calculationResults);
    let value;
    if (typeof min?.value === 'number' && typeof max?.value === 'number')
        value = [min.value, max.value];
    return { type: 'range', min, max, value };
};
const calculate_ExpressionValueTree_Comparison = (description, calculationResults) => {
    const left = calculate_ExpressionValueTree(description.leftHand, calculationResults);
    const right = calculate_ExpressionValueTree(description.rightHand, calculationResults);
    let value;
    if (typeof left?.value === 'number' && typeof right?.value === 'number') {
        switch (description.operator) {
            case 'eq':
                value = left.value === right.value;
                break;
            case 'neq':
                value = left.value !== right.value;
                break;
            case 'gt':
                value = left.value > right.value;
                break;
            case 'gte':
                value = left.value >= right.value;
                break;
            case 'lt':
                value = left.value < right.value;
                break;
            case 'lte':
                value = left.value <= right.value;
                break;
        }
    }
    return { type: 'comparison', left, right, value };
};
const calculate_ExpressionValueTree_Term = (description, calculationResults) => {
    const result = (calculationResults?.[`T${description.termIndex}`])['T'];
    return { type: 'term', value: result };
};
export const calculate_ExpressionValueTree = (description, calculationResults) => {
    if (!calculationResults)
        return;
    switch (description.type) {
        case 'group':
            const inner = calculate_ExpressionValueTree(description.expression, calculationResults);
            return { type: 'group', value: inner?.value, inner };
        case 'binary':
            return calculate_ExpressionValueTree_Binary(description, calculationResults);
        case 'variadic':
            return calculate_ExpressionValueTree_Variadic(description, calculationResults);
        case 'number':
            return { type: 'number', value: description.value };
        case 'unary': {
            return calculate_ExpressionValueTree_Unary(description, calculationResults);
        }
        case 'range':
            return calculate_ExpressionValueTree_Range(description, calculationResults);
        case 'comparison':
            return calculate_ExpressionValueTree_Comparison(description, calculationResults);
        case 'term':
            return calculate_ExpressionValueTree_Term(description, calculationResults);
        case 'atom': {
            throw new BadImplementationException('Not supposed to call this function when description has atoms in it!');
        }
    }
};
//# sourceMappingURL=value-tree.js.map